import React from 'react';
import { Button, Table } from 'react-bootstrap';

export interface SubItem {
  label: string;
  amount: string | number;
  onClick?: () => void;
  isStatic?: boolean;
}

interface ExpandableTableRowProps {
  label: string;
  amount?: string | number;
  actionCell?: React.ReactNode;
  subItems: SubItem[];
  isExpanded: boolean;
  onToggle: () => void;
  rowId: string;
  className?: string;
  style?: React.CSSProperties;
  amountCellStyle?: React.CSSProperties;
}

const ExpandableTableRow: React.FC<ExpandableTableRowProps> = React.memo(({
  label,
  amount,
  actionCell,
  subItems,
  isExpanded,
  onToggle,
  rowId,
  className,
  style,
  amountCellStyle
}) => {
  return (
    <>
      {/* Main expandable row */}
      <tr className={className} style={style}>
        <td>
          <Button
            variant="link"
            onClick={onToggle}
            aria-controls={`collapse-${rowId}`}
            aria-expanded={isExpanded}
          >
            {isExpanded ? '-' : '+'}
          </Button>
          {label}
        </td>
        <td style={amountCellStyle}>{amount || ''}</td>
        <td>{actionCell || ''}</td>
      </tr>

      {/* Expandable content */}
      {isExpanded && (
        <tr id={`collapse-${rowId}`}>
          <td colSpan={3} className='p-0'>
            <Table size="sm" className='mb-0'>
              <tbody>
                {subItems.map((item, index) => (
                  <tr key={index}>
                    <td>
                      {item.isStatic ? (
                        item.label
                      ) : (
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            item.onClick?.();
                          }}
                          style={{ textDecoration: 'underline', cursor: 'pointer' }}
                        >
                          {item.label}
                        </a>
                      )}
                    </td>
                    <td>{item.amount}</td>
                    <td></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </td>
        </tr>
      )}
    </>
  );
});

ExpandableTableRow.displayName = 'ExpandableTableRow';

export default ExpandableTableRow;